export default {
    top_menu: [
        {name:'მთავარი',    id:0},
        {name:'Შოუ ბიზნესი', id:1},
        {name:'სამზარეულო',  id:2},
        {name:'პოლიტიკა',   id:3},
        {name:'+18',  id:4},
        {name:'Საზოგადოება',   id:5},
        {name:'ჯანმრთელობა',   id:6},
    ],
    read_other: 'წაიკითხე მეტი',
    read_more:  'Უფრო ვრცლად',
    not_found:  'Არაფერი არ არის ნაპოვნი',
    read_also:  'წაიკითხეთ ასევე',
    copy_rights: 'Copyright © 2019 «mixer-novostei.ru». Ყველა უფლება დაცულია.',
    subscribe: 'Გამოწერა',

    thank_order: 'მადლობა თქვენი შეკვეთისათვის',
    specialist_contact: 'ჩვენი სპეციალისტი მალე დაგიკავშირდებათ, დაელოდეთ ჩვენს ზარს.',
    attention: 'ფასდაკლება პარტნიორებისგან:',
    hurry: 'იჩქარეთ, ფასდაკლების გააქტიურების დრო შეზღუდულია! თქვენ გაქვთ მხოლოდ <span id="time" class="time">30:00</span> წუთი, რომ აირჩიოთ ერთი ამ უნიკალური პროდუქტიდან:',

    hour_ago1: "Ერთი საათის წინ",
    hour_ago2: "საათის წინ",
    hour_ago3: "საათის წინ",
    new_publications: "ახალი გამოცემები",
    read: "წაიკითხეთ",
    today_at: "დღეს, საათზე",
    author_names: ['GURAM AMARYAN','ELENE NINIDZE','LEVAN KBILASHVILI'],
    main_news: "მთავარი სიახლეები",
    leave_already: "უკვე წასვლა? დაელოდეთ, ჩვენ განვაახლეთ თქვენთვის ახალი ამბები",
    already_shared: "უკვე გაზიარებულია"

}